import React from 'react'
import ThemeMenuSideBar from '../Theme/ThemeMenuSideBar'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Offcanvas from 'react-bootstrap/Offcanvas'


function ThemeNavbar() {
  return (
    <Navbar expand="md">
      <Navbar.Toggle aria-controls="offcanvasNavbar-expand-md" />
      <Navbar.Offcanvas
        id="offcanvasNavbar-expand-md"
        aria-labelledby="offcanvasNavbarLabel-expand-md"
        placement="start"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title id="offcanvasNavbarLabel-expand-md">
            Manpower
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="mobile-offcanvas flex-column w-100">
            <ThemeMenuSideBar />
          </Nav>
        </Offcanvas.Body>
      </Navbar.Offcanvas>        
    </Navbar>   
  )
}

export default ThemeNavbar